<div class="add-to-cart-wrapper-cx">
  <div class="quantity" *ngIf="productCode && showQuantity">
    <cx-item-counter
      *ngIf="hasStock"
      [allowZero]="true"
      [min]="min"
      [max]="max"
      [control]="addToCartForm.get('quantity')"
      (update)="updateCount($event)"
      (keypress)="numberOnly($event)"
      [moq]="minOrderQuantity"
      (hasMinQtyError)="setProductPricingFloatHeight()"
      [readonly]="isDisabled || isLoadDisabled || !hasStock || !hasPDPDealerPrice || isDiscontinued"
    ></cx-item-counter>
  </div>
  <div class="add-to-cart-containter">
    <div
      matTooltip="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
      [matTooltipPosition]="'below'"
      [matTooltipClass]="'button-tooltip'"
      aria-label="displays a tooltip in bottom"
      [matTooltipDisabled]="deviceDetectorService.isMobile() || deviceDetectorService.isTablet()"
    >
      <button
        class="btn btn-primary btn-block btn-add-to-cart"
        type="button"
        [disabled]="
          isDisabled ||
          isLoadDisabled ||
          hasInvalidQuantity ||
          !hasStock ||
          isDiscontinued ||
          ((isProductDetailsPage$ | async) && !hasPDPDealerPrice)
        "
        (click)="backorderCartCheck(orderFormDetails)"
        [ngClass]="{
          rotating: addToCartInprogress
        }"
      >
        <ng-container *ngIf="!addToCartInprogress; else showSpinner">
          <mat-icon svgIcon="add-to-cart"></mat-icon>
        </ng-container>
        <ng-template #showSpinner></ng-template>
      </button>
    </div>
    <button
      class="btn btn-link order-form"
      disableRipple
      *ngIf="showOrderFormLink && baseProduct$ | async as baseProduct"
    >
      <span class="mat-button-wrapper">
        <mat-icon class="material-icons-sharp">shopping_cart</mat-icon>
        <a
          class="align-middle order-form-link"
          [routerLink]="
            { cxRoute: 'orderForm', params: { code: baseProduct?.code, name: escape(baseProduct?.nameHtml) } } | cxUrl
          "
          >{{ 'orderForm.label' | cxTranslate }}</a
        >
      </span>
    </button>
  </div>
</div>
